import React, {useState} from 'react';
import './ServiceItem.css'

const classNames = require('classnames');

function ServiceItemTextBG() {
    return (
        <div className="service-item-text-bg">
            <div className="service-item-text-bg-2">
                <div className="service-item-text-bg-3"/>
            </div>
        </div>
    )
}


export default function ServiceItem(props: {
    title: string,
    children: JSX.Element | Array<JSX.Element> | string,
    src: string,
    className?: string
}) {
    const [mouseOver, setMouseOver] = useState(false);

    function ServiceItemOver() {
        if (!mouseOver) {
            return (<></>)
        }
        return (
            <div className='service-item-text' onMouseLeave={() => {
                (setMouseOver as (mo: boolean) => void)(false)
            }}>
                <ServiceItemTextBG/>
                <p className='service-item-text-contents'>
                    {props.children}
                </p>
                <p className='service-item-text-title'>
                    {props.title}
                </p>
            </div>
        )
    }

    function ServiceItemBase() {
        if (mouseOver) {
            return (<></>)
        }
        return (
            <div className='service-item-base' onMouseOver={() => {
                (setMouseOver as (mo: boolean) => void)(true)
            }}>
                <div className='service-item-bg'/>
                <p className='service-item-title'>
                    {props.title}
                </p>
                <img className='service-item-icon' src={props.src} alt='service-item-icon'/>
            </div>
        )
    }


    return (
        <div className={classNames('service-item', props.className)}>
            {ServiceItemOver()}
            {ServiceItemBase()}
        </div>
    )
}